import React, { useEffect } from "react";

import config from "console_config";

import * as S from "./FullPageRedirect.styles";

export const FullPageRedirect = () => {
  useEffect(() => {
    document.getElementById("fallback")?.remove();
  }, []);

  const redirectPath = [location.pathname, location.search, location.hash].join(
    ""
  );

  return (
    <S.Layout>
      <S.GlobalStyles />
      <S.Container>
        <S.Title>
          Platform.sh is now <S.TitleUpsun>Upsun</S.TitleUpsun>
        </S.Title>
        <S.FirstParagraph>
          We&apos;ve unified our platforms to bring you an even better
          development experience under the Upsun brand. Same powerful platform,
          enhanced capabilities, unified vision.
        </S.FirstParagraph>
        <S.Frame />
        <S.H2>Same great experience, fresh new look.</S.H2>
        <S.SecondParagraph>
          All your existing projects, configurations, and workflows from
          Platform.sh continue to work exactly as before. No action is required
          on your part.
        </S.SecondParagraph>
        <S.Ticks>
          <S.TickContainer>
            <S.Tick /> Same login credentials and account access
          </S.TickContainer>
          <S.TickContainer>
            <S.Tick /> All existing projects and data preserved
          </S.TickContainer>
          <S.TickContainer>
            <S.Tick /> Identical functionality and features
          </S.TickContainer>
        </S.Ticks>
        <S.UpsunButton href={config.CUSTOM_FULL_PAGE_REDIRECT + redirectPath}>
          Go to upsun
        </S.UpsunButton>
      </S.Container>
    </S.Layout>
  );
};
